let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8N2xl")).then(() => parcelRequire('il1j8'));